module.exports = __webpack_public_path__ + "static/media/tab_car.477f9aac.svg";